<section class="mat-typography flex-col flex-gap-10 flex-align-start-center">
  <app-cautare class="flex-row flex-gap-10 flex-col-lt-sm" />

  @if (listaCMJ()) {
    <app-rezultat-cmj class="flex-1-1-auto flex-fill-item" />
  }
  @if (listaCMR()) {
    <app-rezultat-cmr class="flex-1-1-auto flex-fill-item" />
  }

</section>